/* file description */
import type { UseSaveFormProp } from './type';
import { updataAssetModuleByRequest } from '@/common/asset-apis/updataAssetModuleByRequest';
import { addAssetModuleByRequest } from '@/common/asset-apis/addAssetModuleByRequest';
export const useSaveForm: UseSaveFormProp = ({
  namespaceID,
  moduleID,
  recordID,
  FetchAPI,
  moduleInfo,
  formInitData,
}) => {
  return {
    saveRequest: async (values) => {
      if (recordID && recordID !== '0') {
        const mergeValues = {
          ...formInitData?.value?.values,
          ...values,
        };
        // 调用table保存的接口
        const params = {
          moduleInfo,
          namespaceID,
          moduleID,
          record: mergeValues,
          recordKey: recordID,
        };

        const res = await updataAssetModuleByRequest(FetchAPI, params);
        return res;
      } else {
        const res = await addAssetModuleByRequest(FetchAPI, {
          namespaceID,
          moduleID,
          moduleInfo,
          values,
        });
        return res;
      }
    },
  };
};

